import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const Export = ({ title = 'Refresh', ...rest }: IconProps) => (
  <BaseSvg viewBox="0 0 15 16" title={title} {...rest}>
    <g
      id="connector-logs"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="Connector_logs_refresh" transform="translate(-1232.000000, -231.000000)" stroke="currentColor">
        <g id="refresh" transform="translate(1232.000000, 231.000000)">
          <g id="icon_refresh">
            <path
              d="M14.5,8.5 C14.5,12.366 11.366,15.5 7.5,15.5 C3.634,15.5 0.5,12.366 0.5,8.5 C0.5,4.634 3.634,1.5 7.5,1.5 C10.136,1.5 12.328,3.141 13.5,5.5"
              id="Path"
            />
            <polyline id="Path" points="13.5 0.5 13.5 5.5 8.5 5.5" />
          </g>
        </g>
      </g>
    </g>
  </BaseSvg>
)

Export.displayName = 'Refresh'
export default Export
